import styled from "@emotion/styled/macro";
import React, { ButtonHTMLAttributes } from "react";

const StyledButton = styled<"button", { iconUrl?: string }>("button")`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 1px solid #202127;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.5);
  background-image: linear-gradient(to bottom, #edf0f6, #b8bdc8);
  font-weight: 500;
  font-size: 18px;
  padding: 10px 15px;
  position: relative;

  &:before {
    content: "";
    display: ${({ iconUrl }) => (iconUrl ? "block" : "none")};
    background: ${({ iconUrl }) =>
      iconUrl ? `url(${iconUrl}) no-repeat center center transparent` : "none"};
    width: 20px;
    height: 20px;
    margin-right: 15px;
    background-size: contain;
  }

  &[disabled] {
    background: #b8bdc8;
    box-shadow: none;
  }

  &:active {
    box-shadow: none;
    background-image: linear-gradient(to bottom, #b8bdc8, #edf0f6);
  }
`;

const Button = ({
  children,
  iconUrl,
  iconComponent,
  ...rest
}: {
  iconUrl?: string;
  iconComponent?: React.ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>) => (
  <StyledButton iconUrl={iconUrl} {...rest}>
    {iconComponent || null}
    {children}
</StyledButton>
);

export default Button;
